/**
 * Generate UDST term options
 * Format: 1 + YY + T where T: 8=Fall, 1=Winter, 5=Spring
 */
export function generateTermOptions() {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const terms = [];

  for (let year = currentYear - 1; year <= currentYear + 2; year++) {
    const yy = year % 100;
    const nextYy = (year + 1) % 100;

    terms.push({
      code: `1${yy.toString().padStart(2, '0')}8`,
      display: `FALL ${yy.toString().padStart(2, '0')}`,
      year: year,
      order: year * 10 + 3
    });

    terms.push({
      code: `1${nextYy.toString().padStart(2, '0')}1`,
      display: `WINTER ${nextYy.toString().padStart(2, '0')}`,
      year: year + 1,
      order: (year + 1) * 10 + 1
    });

    terms.push({
      code: `1${nextYy.toString().padStart(2, '0')}5`,
      display: `SPRING ${nextYy.toString().padStart(2, '0')}`,
      year: year + 1,
      order: (year + 1) * 10 + 2
    });
  }

  const uniqueTerms = terms.reduce((acc, term) => {
    if (!acc.find(t => t.code === term.code)) {
      acc.push(term);
    }
    return acc;
  }, []);

  uniqueTerms.sort((a, b) => a.order - b.order);

  let defaultTerm;
  if (currentMonth >= 8) {
    defaultTerm = `1${(currentYear % 100).toString().padStart(2, '0')}8`;
  } else if (currentMonth >= 5) {
    defaultTerm = `1${(currentYear % 100).toString().padStart(2, '0')}5`;
  } else {
    defaultTerm = `1${(currentYear % 100).toString().padStart(2, '0')}1`;
  }

  return { terms: uniqueTerms, defaultTerm };
}

/**
 * Format a UDST term code to a human-readable display name
 * e.g., "1261" → "Winter 26", "1258" → "Fall 25"
 */
export function formatTermDisplay(term) {
  if (!term || term.length !== 4) return term || 'Unknown';
  const year = term.substring(1, 3);
  const termCode = term.substring(3);
  const termNames = { '1': 'Winter', '5': 'Spring', '8': 'Fall' };
  return `${termNames[termCode] || 'Term'} ${year}`;
}
